









































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeNotificacoesStore from '@/components/Backoffice/Store/BackofficeNotificacoesStore'
import { humanTime } from '@/utils/common'
import { EmailMensagem, DataTablePagination, EmailMensagemQuery } from '@/types/_'
import _ from 'lodash'

@Component({ filters: { humanTime } })

export default class ViewBackofficeNotificacoes extends Vue {
  tb: string = 'tab-1'

  get getBackofficeNotificacoesStore() {
    return getModule(BackofficeNotificacoesStore, this.$store)
  }

  get tabs() {
    return this.tb
  }

  set tabs(value: string) {
    this.tb = value
  }

  async tabChange(e: string) {
    switch (e) {
      case 'tab-1':
        this.loading = true
        this.getBackofficeNotificacoesStore.setMensagens([])
        await this.loadData('agendamento')
        this.loading = false
        return true
      case 'tab-2':
        this.loading = true
        this.getBackofficeNotificacoesStore.setMensagens([])
        await this.loadData('autorizacao')
        this.loading = false
        return true
      default:
        return ''
    }
  }

  get listSize() {
    return this.getBackofficeNotificacoesStore.listSize
  }

  get pagination() {
    return this.getBackofficeNotificacoesStore.pagination
  }

  get totalItems() {
    return this.getBackofficeNotificacoesStore.totalItems
  }

  get mensagens() {
    return this.getBackofficeNotificacoesStore.mensagens
  }

  get headers() {
    return this.getBackofficeNotificacoesStore.tableHeaders
  }

  get openDialog() {
    return this.getBackofficeNotificacoesStore.emailModal.listagem
  }

  set openDialog(value: boolean) {
    this.getBackofficeNotificacoesStore.setListagem(value)
  }

  get search() {
    return this.getBackofficeNotificacoesStore.search
  }

  set search(value: string) {
    this.getBackofficeNotificacoesStore.setSearch(value)
  }

  get loading() {
    return this.getBackofficeNotificacoesStore.loadingBtn
  }

  set loading(value: boolean) {
    this.getBackofficeNotificacoesStore.setLoadingBtn(value)
  }

  get disabledBtns() {
    return this.getBackofficeNotificacoesStore.disabledBtns
  }

  set disabledBtns(value: boolean) {
    this.getBackofficeNotificacoesStore.setDisabledBtns(value)
  }

  get atualizada() {
    return this.getBackofficeNotificacoesStore.atualizada
  }

  set atualizada(value: boolean) {
    this.getBackofficeNotificacoesStore.setAtualizada(value)
  }

  get naoAtualizada() {
    return this.getBackofficeNotificacoesStore.naoAtualizada
  }

  set naoAtualizada(value: boolean) {
    this.getBackofficeNotificacoesStore.setNaoAtualizada(value)
  }

  get showEmail() {
    return this.getBackofficeNotificacoesStore.emailModal.resolucao
  }

  set showEmail(value: boolean) {
    this.getBackofficeNotificacoesStore.setResolucao(value)
  }

  get email() {
    return this.getBackofficeNotificacoesStore.email
  }

  set email(value: EmailMensagem) {
    this.getBackofficeNotificacoesStore.setEmail(value)
  }

  async updatePagination(pagination: DataTablePagination) {
    this.loading = true
    await this.getBackofficeNotificacoesStore.getMensagens({
      area: this.getArea(),
      pagina: pagination.page,
      qtdPorPagina: pagination.rowsPerPage,
    })
    this.loading = false
  }

  getArea() {
    switch (this.tabs) {
      case 'tab-1':
        return 'agendamento'
      default:
        return 'autorizacao'
    }
  }

  closeDialog() {
    this.search = ''
    this.getBackofficeNotificacoesStore.clearSearch()
    this.getBackofficeNotificacoesStore.clearMensagens()
    this.getBackofficeNotificacoesStore.clearPagination()
    this.getBackofficeNotificacoesStore.clearEmail()
    this.getBackofficeNotificacoesStore.setListagem(false)
  }

  openEmail(item: EmailMensagem) {
    this.getBackofficeNotificacoesStore.setEmail(item)
    this.showEmail = true
  }

  closeEmail() {
    this.getBackofficeNotificacoesStore.resetEmail()
  }

  async updateEmail(id: string) {
    await this.getBackofficeNotificacoesStore.updateEmail(id)
  }

  setDialogStatus() {
    if (this.atualizada) {
      return { color: 'green darken-2', icon: 'check_circle', message: 'Mensagem atualizada!' }
    }

    if (this.naoAtualizada) {
      return { color: 'red darken-2', icon: 'report_problem', message: 'Ocorreu um erro ao atualizar mensagem' }
    }

    return { color: 'indigo darken-2', icon: 'mail', message: 'Mensagem' }
  }

  async loadData(key: string) {
    const query: EmailMensagemQuery = {
      area: key,
      pagina: 1,
      qtdPorPagina: 25,
    }

    await this.getBackofficeNotificacoesStore.getMensagens(query)
  }

  async init() {
    const query: EmailMensagemQuery = {
      area: 'agendamento',
      pagina: 1,
      qtdPorPagina: 25,
    }

    await this.getBackofficeNotificacoesStore.getMensagens(query)
  }

  async created() {
    await this.init()
  }
}
